import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { XCircle } from 'lucide-react';
export function Cancellation() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-405">
      <Header data-id="element-406" />
      <main className="flex-grow" data-id="element-407">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-408">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-409">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6" data-id="element-410">
              <XCircle size={32} data-id="element-411" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-412">
              Cancellation Policy
            </h1>
            <p className="text-xl text-gray-100" data-id="element-413">
              Clear and fair cancellation terms
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-414">
          <div className="max-w-4xl mx-auto px-4" data-id="element-415">
            <div className="prose prose-lg max-w-none" data-id="element-416">
              <div className="bg-gray-50 p-6 rounded-xl mb-8" data-id="element-417">
                <p className="text-sm text-gray-600" data-id="element-418">
                  <strong data-id="element-419">Contact:</strong> info@caringhand.it.com | 0800 055
                  4969
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-420">
                Cancellation Timeframes
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-421">
                We understand that circumstances change. Our cancellation terms
                are designed to be fair and transparent:
              </p>
              <div className="space-y-6 mb-8" data-id="element-422">
                <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-xl" data-id="element-423">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-424">
                    0-14 Days: Full Refund
                  </h3>
                  <p className="text-gray-700" data-id="element-425">
                    Cancel within 14 days of purchase for a full refund,
                    provided no repair work has been carried out. If our
                    engineer has already visited and completed diagnostics or
                    repairs, the cancellation terms below apply.
                  </p>
                </div>
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-xl" data-id="element-426">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-427">
                    15-28 Days: Partial Refund
                  </h3>
                  <p className="text-gray-700" data-id="element-428">
                    Between 15 and 28 days, a partial refund may be granted at
                    our discretion. The amount will depend on whether any work
                    has been completed and the costs already incurred.
                  </p>
                </div>
                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-xl" data-id="element-429">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-430">
                    After 28 Days: No Refund
                  </h3>
                  <p className="text-gray-700" data-id="element-431">
                    After 28 days from the date of purchase, no refunds are
                    available. This allows us to maintain fair pricing and
                    service availability for all customers.
                  </p>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-432">
                How to Cancel
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-433">
                To request a cancellation, please contact us as soon as
                possible:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-434">
                <li data-id="element-435">
                  <strong data-id="element-436">Email:</strong> info@caringhand.it.com with your order
                  details
                </li>
                <li data-id="element-437">
                  <strong data-id="element-438">Phone:</strong> 0800 055 4969 during business hours
                </li>
                <li data-id="element-439">
                  Include your booking reference, name, and contact information
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-440">
                We will acknowledge your cancellation request within 24 hours
                and process any applicable refund to your original payment
                method within 5-10 working days.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-441">
                Exclusions & Special Circumstances
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-442">
                Cancellations may not be eligible for refund in the following
                circumstances:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-443">
                <li data-id="element-444">Pre-existing faults discovered during diagnostics</li>
                <li data-id="element-445">Appliance misuse or damage not caused by our service</li>
                <li data-id="element-446">
                  Work carried out by unauthorised third parties after our visit
                </li>
                <li data-id="element-447">Non-standard modifications or adaptations</li>
                <li data-id="element-448">Commercial or non-domestic use of appliances</li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-449">
                Rescheduling
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-450">
                If you need to reschedule rather than cancel, please contact us
                at least 24 hours before your scheduled appointment. We will do
                our best to find an alternative date that works for you at no
                additional charge.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-451">
                Your Consumer Rights
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-452">
                Nothing in this cancellation policy affects your statutory
                rights under UK consumer law. If you believe your consumer
                rights have been affected, please contact us to discuss your
                concerns.
              </p>
              <div className="bg-[#0D7377] bg-opacity-10 p-6 rounded-xl mt-8" data-id="element-453">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-454">
                  Need Help?
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-455">
                  If you have questions about cancelling your booking or need
                  clarification on our policy, please get in touch:
                </p>
                <div className="space-y-2" data-id="element-456">
                  <p className="text-gray-700" data-id="element-457">
                    <strong data-id="element-458">Email:</strong> info@caringhand.it.com
                  </p>
                  <p className="text-gray-700" data-id="element-459">
                    <strong data-id="element-460">Phone:</strong> 0800 055 4969
                  </p>
                  <p className="text-gray-700" data-id="element-461">
                    <strong data-id="element-462">Address:</strong> 157 Ashley Rd, Hale, Altrincham
                    WA15 9SD
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-463" />
    </div>;
}